export const contactsData = {
    email: 'itzkavindu@gmail.com',
    phone: '+94743718788',
    address: '180/8 Godaparagahawatta, Makandana, Piliyandala.',

    sheetAPI: 'https://sheetdb.io/api/v1/v3cyc3f1hyfyc'
}